// @ts-check
import ToothSelector from './ToothSelector';

export default ToothSelector;
